export default __webpack_public_path__ + "static/media/settings-svgrepo-com.aa77f52a.svg";